import { useSelector } from "react-redux";
import { isBursarUser, isLibrarianUser, showsTeachingPortal } from "../../utils/staffRoles";
import BursarHomePage from "./BursarHomePage";
import LibrarianHomePage from "./LibrarianHomePage";
import TeacherHomePage from "./TeacherHomePage";

/** Dashboard home varies by staff role (bursar, librarian, or teaching staff). */
const StaffHomePage = () => {
    const { currentUser } = useSelector((state) => state.user);
    if (isBursarUser(currentUser)) return <BursarHomePage />;
    if (isLibrarianUser(currentUser)) {
        const withTeaching = showsTeachingPortal(currentUser);
        return (
            <>
                <LibrarianHomePage withTeaching={withTeaching} />
                {withTeaching ? <TeacherHomePage /> : null}
            </>
        );
    }
    return <TeacherHomePage />;
};

export default StaffHomePage;
